// utils/cartHelpers.js

export const normalizeCartItems = (items) => {
    const map = {};
    (Array.isArray(items) ? items : []).forEach((i) => {
      const productId = i?.productId || i?.id || i?.inventoryItemId || "";
      const qRaw = i?.quantity ?? i?.qty ?? i?.count ?? 1;
      const quantity = Number(qRaw);
      if (!productId) return;
      const safeQty = Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      map[productId] = (map[productId] || 0) + safeQty;
    });
  
    return Object.entries(map)
      .map(([productId, quantity]) => ({ productId, quantity }))
      .sort((a, b) => String(a.productId).localeCompare(String(b.productId)));
  };
  
  export const itemsKey = (normalizedItems) =>
    (Array.isArray(normalizedItems) ? normalizedItems : [])
      .map((i) => `${i.productId}:${Number(i.quantity) || 0}`)
      .join("|");